import { createAction } from '@reduxjs/toolkit';
export const FETCH_CALL_QUEUE = 'FETCH_CALL_QUEUE';
export const fetchCallQueueAction = createAction(FETCH_CALL_QUEUE);